<template>
  <div class="d-flex justify-end">
    <v-btn
      @click="openHostSpecialtiesModal"
      color="primary"
      elevation="0"
      class="mr-2"
    >
      <v-icon left>mdi-account-cog</v-icon>
      <span class="d-none d-md-flex body-2">
        {{ $t('host.label.hostSpecialties') }}
      </span>
    </v-btn>

    <v-btn @click="createHostModal" color="primary" elevation="0">
      <v-icon left>mdi-plus</v-icon>
      <span class="d-none d-md-flex body-2">
        {{ $t('create.label.host') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'HostHeaderActions',

  methods: {
    createHostModal() {
      const usersRouterView = this.$parent?.$parent?.$refs.usersRouterView
      usersRouterView?.openCreateHostModal()
    },

    openHostSpecialtiesModal() {
      const usersRouterView = this.$parent?.$parent?.$refs.usersRouterView
      usersRouterView?.openHostSpecialtiesModal()
    },
  },
}
</script>
